import { render, staticRenderFns } from "./KwertyForLeader.vue?vue&type=template&id=ef16a1a4&scoped=true"
import script from "./KwertyForLeader.vue?vue&type=script&lang=js"
export * from "./KwertyForLeader.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=ef16a1a4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef16a1a4",
  null
  
)

export default component.exports